import React, { Component } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import es from "date-fns/locale/es"; // the locale you want
import PaisesDropdown from "../../Comunes/Dropdowns/Paises/PaisesDropdown";
import GenerosDropdown from "../../Comunes/Dropdowns/Generos/GenerosDropdown";
import TextareaAutoajustable from "../../Comunes/TextareaAutoajustable/TextareaAutoajustable";
import NotaEliminacionAcentos from "../Comunes/NotaEliminacionAcentos";
registerLocale("es", es);

class PersonaEntidad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seleccionGenero: 0,
      seleccionPais: 0,
      nombreORazonSocial: "",
      primerApellido: "",
      segundoApellido: "",
      fechaNacimiento: "",
      EsEditable: this.props.EsEditable,
    };

    this._fechaSeleccionada = this._fechaSeleccionada.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  async componentDidMount() {
    await this.cargaInicial();
  }

  async cargaInicial() {
    let datos = this.props.PersonaEntidad;
    this.setState({
      nombreORazonSocial: datos.nombreORazonSocial,
      primerApellido: datos.primerApellido ?? "",
      segundoApellido: datos.segundoApellido ?? "",
      fechaNacimiento: Date.parse(datos.fechaConstitucionONacimiento),
      seleccionGenero: datos.genero ?? "0",
      seleccionPais: datos.paisRegistroONacimiento.codigoPais ?? "0",
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState !== this.state) {
      const personaEntidad = this.props.PersonaEntidad;
      personaEntidad.NombreORazonSocial = this.state.nombreORazonSocial;
      personaEntidad.PrimerApellido = this.state.primerApellido;
      personaEntidad.SegundoApellido = this.state.segundoApellido;
      personaEntidad.FechaConstitucionONacimiento = new Date(
        this.state.fechaNacimiento
      );
      personaEntidad.Genero = this.state.seleccionGenero;
      if (this.state.seleccionPais) {
        personaEntidad.paisRegistroONacimiento.codigoPais =
          this.state.seleccionPais;
      }

      this.props.onChangePersonaEntidad(personaEntidad);
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  async _fechaSeleccionada(date) {
    if (date !== null) {
      this.setState({
        fechaNacimiento: date,
      });
    }
  }

  render() {
    const data = this.props.PersonaEntidad;
    const EsVisible = this.props.VisiblePersonafisica;
    const EsEditable = this.props.EsEditable;

    return (
      <div className="card shadow mb-4">
        <div className="card-header">
          <h6 className="m-0 font-weight-bold text-primary">
            {this.props.Titulo}
          </h6>
        </div>
        <div className="card-body text-gray-800">
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaEntidad.TipoPersona.Codigo"
                className="col-form-label"
              >
                Tipo Persona
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                id="PersonaEntidad.TipoPersona.Codigo"
                value={
                  data.identificacionPrincipal.tipoPersona.descripcionLarga
                }
                readOnly
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              display: EsVisible && data.tipoExtranjero != null ? "" : "none",
            }}
          >
            <div className="col-md-3">
              <label
                htmlFor="PersonaEntidad.TipoExtranjero.Id"
                className="col-form-label"
              >
                Tipo Extranjero
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                id="PersonaEntidad.TipoExtranjero.Id"
                value={data.tipoExtranjero?.descripcion ?? ""}
                readOnly
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaEntidad.IdentificacionPrincipal.Codigo"
                className="col-form-label"
              >
                Identificación
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                id="PersonaEntidad.IdentificacionPrincipal.Codigo"
                value={data.identificacionPrincipal.codigo}
                readOnly
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaEntidad.NombreORazonSocial"
                className="col-form-label"
              >
                Nombre / Razón Social
              </label>
            </div>
            <div className="col-md-9">
              <TextareaAutoajustable
                className="form-control"
                id="PersonaEntidad.NombreORazonSocial"
                name="nombreORazonSocial"
                defaultValue={this.state.nombreORazonSocial}
                style={{
                  textTransform: "uppercase",
                }}
                maxLength={255}
                onChange={this.handleInputChange}
                readOnly={!EsEditable ? true : false}
              />
              {EsEditable && (<NotaEliminacionAcentos/>)} 
            </div>
          </div>
          <div
            className="form-group row"
            style={{ display: EsVisible ? "" : "none" }}
          >
            <div className="col-md-3">
              <label
                htmlFor="PersonaEntidad.PrimerApellido"
                className="col-form-label"
              >
                Primer Apellido
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                style={{ textTransform: "uppercase" }}
                className="form-control"
                id="PersonaEntidad.PrimerApellido"
                name="primerApellido"
                defaultValue={this.state.primerApellido}
                onChange={this.handleInputChange}
                readOnly={!EsEditable ? true : false}
              />
              {EsEditable && (<NotaEliminacionAcentos/>)} 
            </div>
          </div>
          <div
            className="form-group row"
            style={{ display: EsVisible ? "" : "none" }}
          >
            <div className="col-md-3">
              <label
                htmlFor="PersonaEntidad.SegundoApellido"
                className="col-form-label"
              >
                Segundo Apellido
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                style={{ textTransform: "uppercase" }}
                className="form-control"
                id="PersonaEntidad.SegundoApellido"
                name="segundoApellido"
                defaultValue={this.state.segundoApellido}
                onChange={this.handleInputChange}
                readOnly={!EsEditable ? true : false}
              />
              {EsEditable && (<NotaEliminacionAcentos/>)} 
            </div>
          </div>
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaEntidad.FechaConstitucionONacimiento"
                className="col-form-label"
              >
                Fecha Nac. / Const.
              </label>
            </div>
            <div className="col-md-9">
              <DatePicker
                locale="es"
                selected={this.state.fechaNacimiento}
                onChange={this._fechaSeleccionada}
                name="fechaNacimiento"
                dateFormat="dd/MM/yyyy"
                className="form-control"
                disabled={!EsEditable ? true : false}
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaEntidad.PaisRegistroONacimiento"
                className="col-form-label"
              >
                País Nac. / Const.
              </label>
            </div>
            <div className="col-md-9">
              <PaisesDropdown
                id="PersonaEntidad.Pais"
                permiteSeleccionar={EsEditable}
                name="seleccionPais"
                value={this.state.seleccionPais}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{ display: EsVisible ? "" : "none" }}
          >
            <div className="col-md-3">
              <label htmlFor="PersonaEntidad.Genero" className="col-form-label">
                Género
              </label>
            </div>
            <div className="col-md-9">
              <GenerosDropdown
                id="Genero"
                name="seleccionGenero"
                permiteSeleccionar={EsEditable}
                value={this.state.seleccionGenero}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PersonaEntidad;
